import type { FaireProductEntity } from "../../entity_types/product";

export const p_u22h9ny7j7: FaireProductEntity = {
  token: "p_u22h9ny7j7",
  type: "product",
  name: "Scalloped Heart Little Notes® Duo Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3b8b6a596f6ffda8cb9bb9e7522107f6cbbf1cab998ac3ff413eb66b6875fae0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37ab1bc5478016d6090af2d8640ff495fa60919d1a08ce301d2b2fcf9b5de142.jpeg",
    "https://cdn.faire.com/fastly/43408388f6512ade43b7def116c7c7321eeade73c114116a1767f52740ac03fe.jpeg",
    "https://cdn.faire.com/fastly/1b0af61c5d60f076d2e55f7451974a8a7f3dc1ee6e05e77881df95b3ed9b6a44.jpeg",
    "https://cdn.faire.com/fastly/c674ebec41ffe711b903daa2237b0a3d0f36dba453968cf9ae941a45eb5ed86e.jpeg",
  ],
  priceDollars: 6,
  description:
    "The cutest little duos you ever did see. Set of 10 Little Notes® and 10 Little Note Envelopes. These corresponding Little Notes® and printed envelopes take the surprise and delight of Little Notes to the next level - so up your gift tag/secret note/barista tip game! Please note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:21.048Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
